import React, { useState, useEffect } from "react";
import {
  Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Typography, Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Select, MenuItem, FormControl, InputLabel,
  IconButton, Snackbar, Alert
} from "@mui/material";
import {  useLocation } from 'react-router-dom';
import { collection, doc, setDoc, onSnapshot, updateDoc, query, where, getDocs } from "firebase/firestore";
import { db, auth } from "../../firebase";
import EditIcon from "@mui/icons-material/Edit";

const toTitleCase = (str) => {
  return str
    .toLowerCase()
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
const Preferences = () => {
const location = useLocation();
  const [preferences, setPreferences] = useState([]);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [selectedPref, setSelectedPref] = useState(null);

  const defaultPreferences = [
    {
      preferenceType: "Billing",
      preferenceName: "Billing Process",
      preferenceValue: 0
    },
    {
      preferenceType: "Order",
      preferenceName: "Order Number",
      preferenceValue: "RD2526,1"
    },
    {
      preferenceType: "Billing",
      preferenceName: "Payment",  
      preferenceValue: 0
    },
    {
      preferenceType: "Billing",
      preferenceName: "Item Wise Tax",
      preferenceValue: 0
    },
    {
      preferenceType: "Billing",
      preferenceName: "Category To Be Shown Separate",
      preferenceValue: null,
    },
    {
      preferenceType: "Billing",
      preferenceName: "Bill No",
      preferenceValue: "0"
    },
    {
      preferenceType: "Customer",
      preferenceName: "Profile Data",
      preferenceValue: 0
    },
    {
      preferenceType: "Payment",
      preferenceName: "Transaction Details",
      preferenceValue: 0
    },
    {
      preferenceType: "Menu Timing",
      preferenceName: "Morning",
      preferenceValue: {
        from: "06:00",
        to: "11:59"
      }
    },
    {
      preferenceType: "Menu Timing",
      preferenceName: "Afternoon",
      preferenceValue: {
        from: "12:00",
        to: "16:59"
      }
    },
    {
      preferenceType: "Menu Timing",
      preferenceName: "Evening",
      preferenceValue: {
        from: "17:00",
        to: "21:59"
      }
    },
    {
      preferenceType: "Menu Timing",
      preferenceName: "All Day",
      preferenceValue: {
        from: "00:00",
        to: "23:59"
      }
    },
  ];

const companyCode =
  location?.state?.companyCode ||
  new URLSearchParams(location.search).get("code") ||
  sessionStorage.getItem("companyCode") ||
  localStorage.getItem("companyCode") ||
  null;

const unitCode =
  location?.state?.unitCode ||
  new URLSearchParams(location.search).get("unit") ||
  sessionStorage.getItem("unitCode") ||
  localStorage.getItem("unitCode") ||
  null;
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success"
  });
const [categories, setCategories] = useState([]);

   useEffect(() => {

  if (!companyCode || !unitCode) return;

  const q = query(
    collection(db, "categories"),
    where("companyCode", "==", companyCode),
    where("unitCode", "==", unitCode)
  );

  const unsubscribe = onSnapshot(q, (snapshot) => {

    const categoryList = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    setCategories(categoryList);

  });

  return () => unsubscribe();

}, [companyCode, unitCode]);

  /*useEffect(() => {

  if (!companyCode || !unitCode) return;
if (categories.length === 0) return;
  const q = query(
    collection(db, "preferences"),
    where("companyCode", "==", companyCode),
    where("unitCode", "==", unitCode)
  );

  const unsubscribe = onSnapshot(q, async (snapshot) => {

    const list = snapshot.docs.map(docSnap => ({
  id: docSnap.id,
  ...docSnap.data()
}));

    setPreferences(list);

    // 🔹 If no preferences exist → create defaults
    /*if (snapshot.empty) {

      const userId = auth.currentUser?.uid || "unknown";

      for (const pref of defaultPreferences) {

       const docRef = doc(collection(db, "preferences"));

await setDoc(docRef, {
  id: docRef.id,
  companyCode,
  unitCode,
  preferenceType: pref.preferenceType,
  preferenceName: pref.preferenceName,
  preferenceOptions:
  pref.preferenceName === "Billing Process"
    ? [
        "Billing and Order at Counter",
        "Order by Server Billed at counter",
        "Customer Order No KOT",
        "Customer Order",
      ]
    : pref.preferenceName === "Payment"
    ? [
        "Cash",
        "UPI"
      ]
      : pref.preferenceName === "Item Wise Tax"
    ? [
        "True",
        "False"
      ]
    : [],
  preferenceValue: pref.preferenceValue,
  createdAt: new Date().toISOString(),
  createdBy: userId,
  modifiedAt: new Date().toISOString(),
  modifiedBy: userId
});
      }

    }*/
/* const existingPreferenceKeys = list.map(
  p => `${p.companyCode}_${p.unitCode}_${p.preferenceName}`
);

const missingPreferences = defaultPreferences.filter(pref => {
  const key = `${companyCode}_${unitCode}_${pref.preferenceName}`;
  return !existingPreferenceKeys.includes(key);
});

if (missingPreferences.length > 0) {

  const userId = auth.currentUser?.uid || "unknown";

  for (const pref of missingPreferences) {

    const docRef = doc(collection(db, "preferences"));

    await setDoc(docRef, {
      id: docRef.id,
      companyCode,
      unitCode,
      preferenceType: pref.preferenceType,
      preferenceName: pref.preferenceName,

      preferenceOptions:
        pref.preferenceName === "Billing Process"
          ? [
              "Billing and Order at Counter",
              "Order by Server Billed at counter",
              "Customer Order No KOT",
              "Customer Order",
            ]
          : pref.preferenceName === "Payment"
          ? [
              "Cash",
              "UPI"
            ]
          : pref.preferenceName === "Item Wise Tax"
          ? [
              "True",
              "False"
            ]
            : pref.preferenceName === "Category To Be Shown Separate"
? categories.map(cat => cat.categoryName || cat.name)

          : [],

      preferenceValue: pref.preferenceValue,

      createdAt: new Date().toISOString(),
      createdBy: userId,
      modifiedAt: new Date().toISOString(),
      modifiedBy: userId
    });
  }
}

  });

  return () => unsubscribe();

}, [companyCode, unitCode, categories]);*/


useEffect(() => {

  if (!companyCode || !unitCode) return;

  if (categories.length === 0) return;

  const initializePreferences = async () => {

    const q = query(
      collection(db, "preferences"),
      where("companyCode", "==", companyCode),
      where("unitCode", "==", unitCode)
    );

    // GET ONLY ONCE
    const snapshot = await getDocs(q);

    const list = snapshot.docs.map(docSnap => ({
      id: docSnap.id,
      ...docSnap.data()
    }));

    const existingPreferenceNames = list.map(
      p => p.preferenceName
    );

    const missingPreferences = defaultPreferences.filter(
      pref => !existingPreferenceNames.includes(pref.preferenceName)
    );

    // CREATE ONLY MISSING
    if (missingPreferences.length > 0) {

      const userId = auth.currentUser?.uid || "unknown";

      for (const pref of missingPreferences) {

        const docRef = doc(collection(db, "preferences"));

        await setDoc(docRef, {
          id: docRef.id,
          companyCode,
          unitCode,
          preferenceType: pref.preferenceType,
          preferenceName: pref.preferenceName,

          preferenceOptions:
            pref.preferenceName === "Billing Process"
              ? [
                  "Billing and Order at Counter",
                  "Order by Server Billed at counter",
                  "Customer Order No KOT",
                  "Customer Order",
                ]
              : pref.preferenceName === "Payment"
              ? [
                  "Cash",
                  "UPI"
                ]
              : pref.preferenceName === "Item Wise Tax"
              ? [
                  "True",
                  "False"
                ]
              : pref.preferenceName === "Profile Data"
              ? [
                  "True",
                  "False"
                ]
                : pref.preferenceName === "Transaction Details"
              ? [
                  "True",
                  "False"
                ]
              : pref.preferenceName === "Category To Be Shown Separate"
              ? categories.map(cat => cat.categoryName || cat.name)
              : [],

          preferenceValue: pref.preferenceValue,

          createdAt: new Date().toISOString(),
          createdBy: userId,
          modifiedAt: new Date().toISOString(),
          modifiedBy: userId
        });
      }
    }

    // REALTIME LISTENER ONLY FOR DISPLAY
    const unsubscribe = onSnapshot(q, (snap) => {

      const updatedList = snap.docs.map(docSnap => ({
        id: docSnap.id,
        ...docSnap.data()
      }));

      updatedList.forEach(pref => {

    if (pref.preferenceName === "Category To Be Shown Separate") {

      console.log(
        "Category Preference Value:",
        pref.preferenceValue
      );

      console.log(
        "Selected Category Name:",
        pref.preferenceOptions?.[pref.preferenceValue]
      );
    }

  });

      setPreferences(updatedList);

    });

    return unsubscribe;
  };

  let unsubscribeFn;

  initializePreferences().then((unsubscribe) => {
    unsubscribeFn = unsubscribe;
  });

  return () => {
    if (unsubscribeFn) unsubscribeFn();
  };

}, [companyCode, unitCode, categories]);

  const handleUpdatePreference = async () => {
  try {

    if (!selectedPref?.id) return;

    const userId = auth.currentUser?.uid || "unknown";

    const docRef = doc(db, "preferences", selectedPref.id);

    await updateDoc(docRef, {
      preferenceType: selectedPref.preferenceType,
      preferenceName: selectedPref.preferenceName,
     preferenceValue:
  //selectedPref.preferenceName === "Billing Process"
  selectedPref.preferenceType === "Menu Timing"
      ? selectedPref.preferenceValue
  : selectedPref?.preferenceOptions?.length > 0
    ? Number(selectedPref.preferenceValue)
    : selectedPref.preferenceValue,

      modifiedAt: new Date().toISOString(),
      modifiedBy: userId
    });

    setOpenEditDialog(false);

    setSnackbar({
      open: true,
      message: "Preference updated successfully",
      severity: "success"
    });

  } catch (error) {

    console.error("Update error:", error);

    setSnackbar({
      open: true,
      message: "Failed to update preference",
      severity: "error"
    });
  }
};
/*const getPreferenceLabel = (value) => {
  const pref = preferenceOptions.find(p => p.value === value);
  return pref ? `${pref.label},${pref.value}` : value;
};*/

const getPreferenceLabel = (pref) => {
  if (
    pref?.preferenceType === "Menu Timing" &&
    typeof pref.preferenceValue === "object"
  ) {
    return `${pref.preferenceValue.from} - ${pref.preferenceValue.to}`;
  }
  if (
    pref?.preferenceName === "Category To Be Shown Separate"
  ) {
    return (
      pref?.preferenceOptions?.[pref.preferenceValue] || ""
    );
  }

  if (!pref?.preferenceOptions) return pref.preferenceValue;

  return pref.preferenceOptions[pref.preferenceValue] || pref.preferenceValue;
};
  return (

    <Box sx={{ p: 4 }}>

      <Box
  sx={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mb: 3
  }}
>
  <Typography variant="h4" sx={{ fontWeight: "bold" }}>
    Preferences Master
  </Typography>


</Box>

      <TableContainer component={Paper}>
        <Table>

          <TableHead>
            <TableRow>
              <TableCell><b>Preference Type</b></TableCell>
              <TableCell><b>Preference Name</b></TableCell>
              <TableCell><b>Preference Value</b></TableCell>
              <TableCell><b>Actions</b></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>

            {preferences.map(pref => (

              <TableRow key={pref.id}>

                <TableCell>{pref.preferenceType}</TableCell>

                <TableCell>{pref.preferenceName}</TableCell>

                {/*<TableCell>{getPreferenceLabel(pref.preferenceValue)}</TableCell>*/}
<TableCell>{getPreferenceLabel(pref)}</TableCell>
                <TableCell>

                  <IconButton
                    color="primary"
                    onClick={() => {
                      setSelectedPref(pref);
                      setOpenEditDialog(true);
                    }}
                  >
                    <EditIcon />
                  </IconButton>
                </TableCell>

              </TableRow>

            ))}

          </TableBody>

        </Table>
      </TableContainer>
      {/* EDIT DIALOG */}

      <Dialog open={openEditDialog}>

        <DialogTitle>Edit Preference</DialogTitle>

        <DialogContent>

          <TextField
            label="Preference Type"
            fullWidth
            margin="dense"
            value={selectedPref?.preferenceType || ""}
            onChange={(e) =>
  setSelectedPref({
    ...selectedPref,
    preferenceType: toTitleCase(e.target.value)
  })
}
          />

          <TextField
            label="Preference Name"
            fullWidth
            margin="dense"
            value={selectedPref?.preferenceName || ""}
            onChange={(e) =>
  setSelectedPref({
    ...selectedPref,
    preferenceName: toTitleCase(e.target.value)
  })
}
          />

{selectedPref?.preferenceType === "Menu Timing" ? (

  <>
    <TextField
      label="From Time"
      type="time"
      fullWidth
      margin="dense"
      InputLabelProps={{ shrink: true }}
      value={selectedPref?.preferenceValue?.from || ""}
      onChange={(e) =>
        setSelectedPref({
          ...selectedPref,
          preferenceValue: {
            ...selectedPref.preferenceValue,
            from: e.target.value
          }
        })
      }
    />

    <TextField
      label="To Time"
      type="time"
      fullWidth
      margin="dense"
      InputLabelProps={{ shrink: true }}
      value={selectedPref?.preferenceValue?.to || ""}
      onChange={(e) =>
        setSelectedPref({
          ...selectedPref,
          preferenceValue: {
            ...selectedPref.preferenceValue,
            to: e.target.value
          }
        })
      }
    />
  </>

) : 
      selectedPref?.preferenceOptions?.length > 0 ? (

<FormControl fullWidth margin="dense">
  <InputLabel>Preference Value</InputLabel>

  <Select
    value={selectedPref?.preferenceValue ?? ""}
    label="Preference Value"
    onChange={(e) =>
      setSelectedPref({
        ...selectedPref,
        preferenceValue: e.target.value
      })
    }
  >
    {/*{preferenceOptions.map(option => (
      <MenuItem key={option.value} value={option.value}>
        {option.label},{option.value}
      </MenuItem>
    ))}*/}

    {selectedPref?.preferenceOptions?.map((option, index) => (
  <MenuItem key={index} value={index}>
    {option},{index}
  </MenuItem>
))}
  </Select>

</FormControl>

) : (

<TextField
  label="Preference Value"
  fullWidth
  margin="dense"
  //value={selectedPref?.preferenceValue || ""}
   value={selectedPref?.preferenceValue ?? ""}
  onChange={(e) =>
    setSelectedPref({
      ...selectedPref,
      preferenceValue: e.target.value
    })
  }
/>

)}

        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenEditDialog(false)}>Cancel</Button>
          <Button onClick={handleUpdatePreference}>Update</Button>
        </DialogActions>

      </Dialog>

     <Snackbar
       open={snackbar.open}
       autoHideDuration={3000}
       onClose={() => setSnackbar({ ...snackbar, open: false })}
       anchorOrigin={{ vertical: "top", horizontal: "right" }}
     >
     <Alert
       severity={snackbar.severity}
       variant="outlined"
       onClose={() => setSnackbar({ ...snackbar, open: false })}
       sx={{
         backgroundColor: "#fff",
         color: "#000",
         border: "1px solid #ddd",
         fontWeight: "bold",
         fontSize: "16px"
       }}
     >
       {snackbar.message}
     </Alert>
     </Snackbar>

    </Box>
  );
};

export default Preferences;